import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

import FooterComponen from '../../components/footer';
import { URL_AWS } from '../../constans/servidor';
import * as ROUTES from '../../constans/rutas';

const IMG_FONDO_CEL = 
  'https://firebasestorage.googleapis.com/v0/b/beparking2023.appspot.com/o/Images%2Ffondo-landing-mundial_CELULAR.png?alt=media&token=68da31ad-01e3-4348-af4b-3d8dd2d2a26a';
const IMG_FONDO =
  'https://firebasestorage.googleapis.com/v0/b/beparking2023.appspot.com/o/Images%2Ffondo-landing-mundial_dise%C3%B1oFINAL.png?alt=media&token=3c596345-4cb0-4e05-ba02-97e8c084b4ca';
const IMG_LOGO_TEAM =
  'https://firebasestorage.googleapis.com/v0/b/beparking2023.appspot.com/o/Images%2Fsello-mundial.png?alt=media&token=a3dc38bc-0825-480f-9b28-f00a07ef4ad2';
const VERDE = '#90d400';

const PARQUEADEROS_PERMITIDOS = [
  'EDIFICIO BAMBU',
  'CRA 5 CL 18 CENTRO',
  'MONTSALUD',
  'SAN MARCOS',
  'EDIFICIO PERCALES',
  'HOTEL W',
  'COLINA OFFICE PARK',
  'HELM BANK',
  'CEDRITOS',
  'SANTOTO STO. DOMINGO I',
  'ACOCENTRO 118',
  'CLINICA SAN RAFAEL II',
  'LAFAYETTE',
  'CLINICA SAN RAFAEL',
  'NEW PORT',
  'CASA DE LA CERVEZA',
  'CENTRO COMETA',
  'KONRAD LORENZ',
];

const styleHoverBtn = `
  .btn-registrar-campana:hover:not(:disabled) {
    background-color: ${VERDE} !important;
    border-color: ${VERDE} !important;
    color: #fff !important;
    text-decoration: underline !important;
    text-underline-offset: 3px;
  }
`;

const CampanaMundial = () => {
  const [loading, setLoading] = useState(false);
  const [registrado, setRegistrado] = useState(false);
  const [formData, setFormData] = useState({ cedula: '', numeroFactura: '', parqueadero: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'parqueadero') {
      setFormData((prev) => ({ ...prev, [name]: value }));
    } else {
      const soloNumeros = value.replace(/\D/g, '');
      setFormData((prev) => ({ ...prev, [name]: soloNumeros }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const cedula = formData.cedula || '';
    const numeroFactura = formData.numeroFactura || '';
    const parqueadero = (formData.parqueadero || '').trim();
    if (!cedula || !numeroFactura) {
      toast.warning('Completa cédula y número de factura.');
      return;
    }
    if (cedula.length < 5) {
      toast.warning('La cédula debe tener al menos 5 caracteres.');
      return;
    }
    if (cedula.length > 12) {
      toast.warning('La cédula no puede tener más de 12 caracteres.');
      return;
    }
    if (numeroFactura.length > 10) {
      toast.warning('El número de factura no puede tener más de 10 caracteres.');
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${URL_AWS}/beParking/campanaMundial-2026/registrar`, {
        cedula,
        numeroFactura,
        parqueadero,
      });
      setRegistrado(true);
      setFormData({ cedula: '', numeroFactura: '', parqueadero: '' });
      toast.success('Factura registrada correctamente. ¡Gracias por participar!');
    } catch (err) {
      const isNetworkError =
        err?.message === 'Network Error' || err?.code === 'ERR_NETWORK' || !err?.response;
      const msg = isNetworkError
        ? 'No se pudo conectar con el servidor. Revisa tu conexión o intenta más tarde.'
        : err?.response?.data?.message ||
          err?.message ||
          'No se pudo registrar la factura. Intenta de nuevo.';
      const link = err?.response?.data?.link;
      if (link && typeof msg === 'string') {
        let textoSinUrl = msg.replace(/\s+aquí:\s*https?:\/\/[^\s]+/gi, '').trim();
        textoSinUrl = textoSinUrl.replace(/\s+aquí\.?\s*$/i, '').trim();
        const tieneAqui = /aquí/i.test(textoSinUrl);
        if (tieneAqui) {
          const partes = textoSinUrl.split(/(aquí)/i);
          const contenido = partes.map((p, i) =>
            p.toLowerCase() === 'aquí' ? (
              <a
                key={i}
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#fff', textDecoration: 'underline', fontWeight: 700 }}
              >
                aquí
              </a>
            ) : (
              p
            )
          );
          toast.error(<>{contenido}</>);
        } else {
          toast.error(
            <>
              {textoSinUrl}{' '}
              <a
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#fff', textDecoration: 'underline', fontWeight: 700 }}
              >
                aquí
              </a>
              .
            </>
          );
        }
      } else {
        toast.error(msg);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{`
        .campana-page { overflow-x: hidden; max-width: 100vw; }
        .campana-container { max-width: 100%; overflow-x: hidden; }
        .Toastify__toast--error {
          background: linear-gradient(135deg, #dc3545 0%, #c82333 100%) !important;
          border-radius: 12px !important;
          box-shadow: 0 4px 16px rgba(220, 53, 69, 0.4) !important;
          padding: 1rem 1.25rem !important;
          font-size: 0.95rem !important;
          min-height: auto !important;
          border: 1px solid rgba(255, 255, 255, 0.1) !important;
        }
        .Toastify__toast--error .Toastify__toast-body {
          padding: 0 !important;
          margin: 0 !important;
        }
        .Toastify__toast--error a {
          color: #fff !important;
          text-decoration: underline !important;
          font-weight: 700 !important;
          transition: opacity 0.2s !important;
        }
        .Toastify__toast--error a:hover {
          opacity: 0.85 !important;
        }
        @media (max-width: 991.98px) {
          .campana-page { 
            background-image: url(${IMG_FONDO_CEL}) !important; 
            background-position: center center !important; 
            background-attachment: scroll !important;}   
          .campana-container { padding-left: 0.75rem !important; ... }
          .campana-container { padding-left: 0.75rem !important; padding-right: 0.75rem !important; padding-top: 1.25rem !important; }
          .campana-row { margin-left: -0.75rem !important; margin-right: -0.75rem !important; }
          .campana-row [class*="col"] { padding-left: 0.75rem !important; padding-right: 0.75rem !important; }
          .campana-centro { margin-left: 0 !important; margin-top: 0 !important; }
          .aplican-link { margin-top: 0.25rem !important; }
          .participar-block { margin-left: 0 !important; margin-top: 0.35rem !important; }
          .participar-block .participar-titulo { margin-bottom: 0.35rem !important; }
          .campana-form-col { padding-left: 0.75rem !important; padding-right: 0.75rem !important; margin-top: 0.9rem !important; }
          .campana-form-wrap {
            max-width: 100% !important;
            min-width: 0 !important;
            box-sizing: border-box !important;
            padding-left: 0.75rem !important;
            padding-right: 0.75rem !important;
          }
          .campana-form-wrap input,
          .campana-form-wrap button,
          .campana-form-wrap .form-control { max-width: 100% !important; box-sizing: border-box !important; }
          .campana-hero-text,
          .campana-hero-text h2,
          .campana-hero-text p {
            text-shadow: 0 1px 3px rgba(0,0,0,0.9), 0 2px 8px rgba(0,0,0,0.8), 0 0 24px rgba(0,0,0,0.6) !important;
          }
          .campana-hero-text {
            padding: 0.4rem 0.6rem;
            border-radius: 8px;
            background: rgba(0,0,0,0.5);
            display: inline-block;
          }
          .campana-hero-mobile { margin-bottom: 0.25rem !important; margin-top: 0.85rem !important; }
          .campana-sello-mobile { margin-top: -3rem !important; }
          .campana-participar-pasos { gap: 0.25rem !important; }
          .campana-participar-pasos .campana-paso-item { padding: 0.28rem 0.7rem !important; font-size: 0.85rem !important; }
          .participar-block .participar-titulo { font-size: 0.9rem !important; }
          .campana-centro .aplican-link { white-space: normal !important; text-align: left !important; margin-bottom: 0 !important; }
          .campana-centro { margin-bottom: 0.2rem !important; }
          .campana-centro .aplican-link { margin-top: -1rem !important; }
          .campana-centro { align-items: flex-start !important; }
        }
      `}</style>
      <div
        className="campana-page"
        style={{
          position: 'relative',
          minHeight: '100vh',
          backgroundImage: `url(${IMG_FONDO})`,
          backgroundSize: 'cover',
          backgroundPosition: '50% -45%',
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: 'fixed',
        }}
      >
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(to bottom, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.45) 100%)',
            pointerEvents: 'none',
          }}
        />
        <Container
          fluid
          className="pt-0 pb-5 campana-container"
          style={{ position: 'relative', zIndex: 1, paddingTop: 0 }}
        >
          {/* Tres columnas en desktop; en móvil: orden sello+derecha/texto izquierda → Participar → Aplican → form */}
          <Row className="align-items-start justify-content-between campana-row" style={{ marginTop: '-0.5rem', minHeight: '80vh' }}>
            {/* Columna izquierda - textos campaña */}
            <Col xs={12} lg={5} className="mb-4 mb-lg-0 order-1 order-lg-1">
              {/* Solo móvil: fila con PARQUEA (izq) y sello (der) */}
              <Row className="d-lg-none mx-0 campana-hero-mobile">
                <Col xs={7} className="pe-1">
                  <div
                    className="campana-hero-text"
                    style={{
                      color: '#fff',
                      fontFamily: 'Conv_Gotham-Bold, sans-serif',
                      marginTop: 0,
                      marginLeft: 0,
                    }}
                  >
                    <h2 style={{ fontSize: '1.25rem', lineHeight: 1.15, marginBottom: '0.2rem' }}>
                      <span style={{ color: VERDE }}>PARQUEA</span><br />
                      <span style={{ color: '#fff', fontWeight: 700 }}>donde siempre,</span>
                    </h2>
                    <h2 style={{ fontSize: '1.25rem', lineHeight: 1.15, marginBottom: '0.2rem' }}>
                      <span style={{ color: VERDE }}>GANA</span><br />
                      <span style={{ color: '#fff', fontWeight: 700 }}>como nunca</span>
                    </h2>
                    <p style={{ fontSize: '0.9rem', marginBottom: 0, color: '#fff', fontWeight: 700 }}>
                      Vive la emoción del Mundial como hincha estrella.
                    </p>
                  </div>
                </Col>
                <Col xs={5} className="d-flex justify-content-end align-items-center ps-1">
                  <img
                    src={IMG_LOGO_TEAM}
                    alt="El Team Mundialista"
                    className="campana-sello-mobile"
                    style={{ maxWidth: '90px', width: '100%', height: 'auto', filter: 'drop-shadow(0 4px 12px rgba(0,0,0,0.4))' }}
                  />
                </Col>
              </Row>
              {/* Desktop: bloque PARQUEA */}
              <div
                className="d-none d-lg-block"
                style={{
                  color: '#fff',
                  fontFamily: 'Conv_Gotham-Bold, sans-serif',
                  textShadow: '0 2px 8px rgba(0,0,0,0.5)',
                  marginTop: '1rem',
                  marginLeft: '1.5rem',
                }}
              >
                <h2
                  style={{
                    fontSize: 'clamp(1.25rem, 3.2vw, 2.5rem)',
                    lineHeight: 1.15,
                    marginBottom: '0.2rem',
                  }}
                >
                  <span style={{ color: VERDE }}>PARQUEA</span>
                  <br />
                  <span style={{ color: '#fff', fontWeight: 700 }}>donde siempre,</span>
                </h2>
                <h2
                  style={{
                    fontSize: 'clamp(1.25rem, 3.2vw, 2.5rem)',
                    lineHeight: 1.15,
                    marginBottom: '0.35rem',
                  }}
                >
                  <span style={{ color: VERDE }}>GANA</span>
                  <br />
                  <span style={{ color: '#fff', fontWeight: 700 }}>como nunca</span>
                </h2>
                <p
                  style={{
                    fontSize: '1rem',
                    marginBottom: '4rem',
                    color: '#fff',
                    fontWeight: 700,
                  }}
                >
                  Vive la emoción del Mundial como hincha estrella.
                </p>
              </div>
              {/* Participar bloque - más abajo */}
                <div
                  style={{
                    color: '#fff',
                    fontFamily: 'Conv_Gotham-Bold, sans-serif',
                    textShadow: '0 2px 8px rgba(0,0,0,0.5)',
                    marginTop: '2.5rem',
                    marginLeft: '1.5rem',
                  }}
                  className="participar-block"
                >
                  <p
                    className="participar-titulo"
                    style={{
                      fontSize: '1rem',
                      marginBottom: '0.4rem',
                      color: '#fff',
                      fontWeight: 700,
                      opacity: 0.95,
                    }}
                  >
                    Participar es muy fácil
                  </p>
                  <div className="campana-participar-pasos" style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem', width: 'fit-content' }}>
                    {[
                      'Parquea en Parking',
                      'Acumula puntos be parking',
                      'Registra tus facturas',
                    ].map((texto, i) => (
                      <div
                        key={i}
                        className="campana-paso-item"
                        style={{
                          backgroundColor: VERDE,
                          color: '#fff',
                          padding: '0.4rem 1rem',
                          borderRadius: '8px',
                          width: '100%',
                          fontWeight: 600,
                        }}
                      >
                        {i + 1}. {texto}
                      </div>
                    ))}
                  </div>
                </div>
            </Col>

            {/* Columna centro - sello solo desktop + Aplican términos */}
            <Col xs={12} lg={2} className="d-flex flex-column justify-content-start align-items-center mb-4 mb-lg-0 order-2 order-lg-2 campana-centro" style={{ marginLeft: '-7rem', marginTop: '1.70rem' }}>
              <img
                src={IMG_LOGO_TEAM}
                alt="El Team Mundialista"
                className="d-none d-lg-block"
                style={{
                  maxWidth: '115px',
                  width: '100%',
                  height: 'auto',
                  filter: 'drop-shadow(0 4px 12px rgba(0,0,0,0.4))',
                }}
              />
              <Link
                to={ROUTES.TYC_CAMPANA_MUNDIAL}
                className="aplican-link"
                style={{
                  marginTop: '18.2rem',
                  fontSize: '0.9rem',
                  color: '#fff',
                  fontWeight: 700,
                  opacity: 0.95,
                  textAlign: 'center',
                  whiteSpace: 'nowrap',
                  textDecoration: 'underline',
                  textUnderlineOffset: '0.2rem',
                  cursor: 'pointer',
                  transition: 'opacity 0.2s, color 0.2s',
                  display: 'inline-block',
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.opacity = '1';
                  e.currentTarget.style.color = VERDE;
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.opacity = '0.95';
                  e.currentTarget.style.color = '#fff';
                }}
              >
                Aplican términos y condiciones.
              </Link>
            </Col>

            {/* Columna derecha - formulario centrado (un poco más abajo) */}
            <Col xs={12} lg={5} className="d-flex justify-content-end align-items-center order-3 campana-form-col" style={{ marginTop: '1.3rem', paddingRight: '2.5rem' }}>
              <div
                className="campana-form-wrap"
                style={{
                  background: 'rgba(255,255,255,0.95)',
                  borderRadius: '16px',
                  padding: '0.35rem 0.75rem',
                  boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
                  maxWidth: '340px',
                  width: '100%',
                  minWidth: 0,
                }}
              >
                {registrado ? (
                  <div className="text-center py-3">
                    <p style={{ color: VERDE, fontWeight: 600, fontSize: '1.1rem' }}>
                      ✓ Factura registrada correctamente
                    </p>
                    <p style={{ color: '#666', marginBottom: 0 }}>
                      Puedes registrar más facturas durante el periodo de campaña.
                    </p>
                    <Button
                      variant="outline-success"
                      className="mt-3"
                      onClick={() => setRegistrado(false)}
                    >
                      Registrar otra factura
                    </Button>
                  </div>
                ) : (
                  <>
                    <h4
                      style={{
                        color: VERDE,
                        fontFamily: 'Conv_Gotham-Bold, sans-serif',
                        marginBottom: '0.25rem',
                        fontSize: '0.95rem',
                      }}
                    >
                      ¡REGISTRATE!
                    </h4>
                    <p
                      style={{
                        color: '#333',
                        fontWeight: 700,
                        fontSize: '0.78rem',
                        marginBottom: '0.25rem',
                        lineHeight: 1.35,
                      }}
                    >
                      Participa por una experiencia para ver un partido con cuatro acompañantes, por un valor de hasta <strong>$1.000.000</strong> en Bogotá.
                    </p>
                    <p
                      style={{
                        color: '#666',
                        fontSize: '0.7rem',
                        marginTop: '0.1rem',
                        marginBottom: '0.3rem',
                        lineHeight: 1.3,
                      }}
                    >
                      Espera 30 minutos después de tu transacción para que la factura aparezca en el sistema. Luego regístrala y participa por la experiencia de ver el partido.
                    </p>
                    <Form onSubmit={handleSubmit}>
                      <Form.Group className="mb-0" style={{ marginBottom: '0.2rem' }}>
                        <Form.Label style={{ color: '#333', fontWeight: 700, fontSize: '0.85rem' }}>
                          Cédula *
                        </Form.Label>
                        <Form.Control
                          type="text"
                          inputMode="numeric"
                          autoComplete="off"
                          name="cedula"
                          value={formData.cedula}
                          onChange={handleChange}
                          placeholder="Número de cédula"
                          required
                          minLength={5}
                          maxLength={12}
                          style={{ padding: '0.3rem 0.5rem', fontSize: '0.875rem' }}
                        />
                      </Form.Group>
                      <Form.Group className="mb-0" style={{ marginBottom: '0.2rem' }}>
                        <Form.Label style={{ color: '#333', fontWeight: 700, fontSize: '0.85rem' }}>
                          Factura *
                        </Form.Label>
                        <Form.Control
                          type="text"
                          inputMode="numeric"
                          autoComplete="off"
                          name="numeroFactura"
                          value={formData.numeroFactura}
                          onChange={handleChange}
                          placeholder="Número de factura"
                          required
                          maxLength={10}
                          style={{ padding: '0.3rem 0.5rem', fontSize: '0.875rem' }}
                        />
                      </Form.Group>
                      <Form.Group className="mb-0" style={{ marginBottom: '0.2rem' }}>
                        <Form.Label style={{ color: '#333', fontWeight: 700, fontSize: '0.85rem' }}>
                          Parqueadero
                        </Form.Label>
                        <Form.Control
                          type="text"
                          autoComplete="off"
                          name="parqueadero"
                          value={formData.parqueadero}
                          onChange={handleChange}
                          placeholder="Nombre parqueadero"
                          style={{ padding: '0.3rem 0.5rem', fontSize: '0.875rem' }}
                        />
                        <Form.Text as="small" className="d-block mt-0" style={{ color: '#6ab04c', fontSize: '0.58rem', marginTop: '0.15rem' }}>
                          Escríbelo exactamente como aparece en tu factura.
                        </Form.Text>
                      </Form.Group>
                      <>
                        <style>{styleHoverBtn}</style>
                        <Button
                          type="submit"
                          disabled={loading}
                          className="btn-registrar-campana"
                          style={{
                            backgroundColor: VERDE,
                            borderColor: VERDE,
                            color: '#fff',
                            fontWeight: 600,
                            width: '100%',
                            padding: '0.35rem',
                          }}
                        >
                          {loading ? 'Registrando…' : 'Registrar'}
                        </Button>
                      </>
                    </Form>
                    <p
                      style={{
                        color: '#333',
                        fontWeight: 700,
                        fontSize: '0.74rem',
                        marginTop: '0.25rem',
                        marginBottom: 0,
                      }}
                    >
                      Entre más visitas registres, más oportunidades tendrás de ganar.
                    </p>
                    <p
                      style={{
                        color: '#666',
                        fontSize: '0.68rem',
                        marginTop: '0.12rem',
                        marginBottom: 0,
                      }}
                    >
                      Solo aplica para visitas entre el 23 de febrero y 23 de abril de 2026.
                    </p>
                  </>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <FooterComponen />
    </>
  );
};

export default CampanaMundial;
